import { FunctionComponent, useEffect, useState } from "react";
import $ from "jquery";
import "./styles/Navbar.css";
import { Flex, Modal, Typography } from "antd";

interface NavbarProps {}

const Navbar: FunctionComponent<NavbarProps> = () => {
  const [scroll, setScroll] = useState<string>("");
  const [active, setActive] = useState<string>("aboutMe");
  const [openContact, setOpenContact] = useState<boolean>(false);

  const scrollFun = (id: string) => {
    var reqId = "#" + id;
    window.scrollTo({
      top: ($(reqId)?.offset()?.top ?? 0) - 100,
      behavior: "smooth",
    });
    setActive(id);
  };

  const handleCloseContact = () => {
    setOpenContact(false);
  };

  useEffect(() => {
    document.addEventListener("scroll", () => {
      setScroll(window.scrollY < 100 ? "" : "scrolled");
      if (window.scrollY + 200 < ($("#aboutMe")?.offset()?.top ?? 0)) {
        setActive("aboutMe");
      } else if (
        window.scrollY + 200 >= ($("#aboutMe")?.offset()?.top ?? 0) &&
        window.scrollY + 200 < ($("#nfz")?.offset()?.top ?? 0)
      ) {
        setActive("aboutMe");
      } else if (
        window.scrollY + 200 >= ($("#nfz")?.offset()?.top ?? 0) &&
        window.scrollY + 200 < ($("#hospitals")?.offset()?.top ?? 0)
      ) {
        setActive("nfz");
      } else if (
        window.scrollY + 200 >= ($("#hospitals")?.offset()?.top ?? 0) &&
        window.scrollY + 200 < ($("#private")?.offset()?.top ?? 0)
      ) {
        setActive("hospitals");
      } else if (window.scrollY + 200 >= ($("#private")?.offset()?.top ?? 0)) {
        setActive("private");
      }
    });

    return () => {
      document.removeEventListener("scroll", () => {});
    };
  }, []);

  return (
    <div className={"navbar " + scroll}>
      {/* <HeaderLogo /> */}
      <div className="logo">
        <h3>Mariusz Sroczyński</h3>
      </div>
      <div className="menu">
        <button
          className={"menu-item " + (active === "aboutMe" ? "active" : "")}
          onClick={() => scrollFun("aboutMe")}
        >
          O mnie
        </button>
        <button
          className={"menu-item " + (active === "nfz" ? "active" : "")}
          onClick={() => scrollFun("nfz")}
        >
          Poradnia Chirurgii Dziecięcej - NFZ
        </button>
        <button
          className={"menu-item " + (active === "hospitals" ? "active" : "")}
          onClick={() => scrollFun("hospitals")}
        >
          Operacje w szpitalu
        </button>
        <button
          className={"menu-item " + (active === "private" ? "active" : "")}
          onClick={() => scrollFun("private")}
        >
          Wizyty prywatne
        </button>
      </div>
      <div className="button-container">
        <button
          onClick={() => {
            setOpenContact(true);
          }}
        >
          Kontakt
        </button>
      </div>
      <Modal
        centered
        footer={null}
        open={openContact}
        onCancel={handleCloseContact}
        width={400}
        title="Kontakt"
        destroyOnClose
      >
        <Flex
          vertical
          style={{
            paddingTop: "24px",
          }}
          justify="center"
          align="center"
        >
          <Typography.Title level={4}>
            W pilnych sprawach proszę o kontakt telefoniczny:
          </Typography.Title>
          <Typography.Title level={4}>+48 507 191 600</Typography.Title>
        </Flex>
      </Modal>
    </div>
  );
};

export default Navbar;
